export default __webpack_public_path__ + "static/media/BD.79adcde3.svg";